import clsx from 'clsx'
import { ArrowRightIcon, ShieldPlusIcon, XIcon } from 'lucide-react'

import { type MedicalPlanDisplayItem } from 'components/member_onboarding_v2/medicalPlanTypes'
import { Button, IconButton, Tooltip } from 'slab'

import { PlanCardPremium } from '../PlanCard/Premium'
import { PlanChip } from '../PlanChip'
import { MAX_PLANS_TO_VERIFY, useProviderInNetworkVerificationContext } from '../ProviderInNetworkVerificationContext/ProviderInNetworkVerificationContext'

export const InNetworkPlansCard: React.FC<{
  disabled?: boolean
  plans: MedicalPlanDisplayItem[];
  onRemovePlan?: (planId: string) => void;
  onSelectMorePlansForVerification?: () => void;
}> = ({ disabled, plans, onRemovePlan, onSelectMorePlansForVerification }) => {
  const { canAddMorePlans } = useProviderInNetworkVerificationContext()
  return (
    <div className='border rounded-lg border-gray-400 bg-white overflow-hidden'>
      <div className='flex flex-col p-4'>
        <div className='flex items-center justify-between'>
          <div className='flex gap-1 mb-1 items-center'>
            <ShieldPlusIcon className='text-gray-400' size={14} />
            <span className='body-bold'>Plans to check</span>
          </div>
          {
            onSelectMorePlansForVerification && (
              <Tooltip enabled={!canAddMorePlans} content={`A maximum of ${MAX_PLANS_TO_VERIFY} plans can be selected`}>
                <Button disabled={!canAddMorePlans} onClick={onSelectMorePlansForVerification} variant='tertiary' rightIcon={ArrowRightIcon}>
                  Select more plans
                </Button>
              </Tooltip>
            )
          }
        </div>
        {!disabled && <span className='body-sm text-gray-500 mb-3'>We can check up to {MAX_PLANS_TO_VERIFY} plans for you</span>}
        <div className='flex flex-col gap-2' data-testid='plans-to-verify'>
          {
            plans.map((planDisplayItem) => {
              const plan = planDisplayItem.plan
              const premium = Number(
                ((planDisplayItem.total_premium.subunits || 0) / 100).toFixed(2)
              )
              return (
                <div className='p-3 border rounded-lg shadow-sm' key={plan.id}>
                  <div className='flex gap-2 items-center'>
                    <div className={clsx('flex-1 border-gray-200', { 'border-r': onRemovePlan })}>
                      <PlanChip
                        carrierLogo={plan.carrier_image_url ?? ''}
                        carrierName={plan.carrier_name}
                        planName={plan.friendly_name}
                      />
                    </div>
                    {
                      onRemovePlan
                        ? (
                          <IconButton onClick={() => onRemovePlan(plan.id)} icon={XIcon} label='Close' />
                          )
                        : (
                          <div className='self-end'>
                            <PlanCardPremium amount={premium} displayMode='compact' bold={false} />
                          </div>
                          )
                    }
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    </div>
  )
}
